import React from 'react';

import Button from '../common/Button/Button';

import { TestID } from 'src/testID';

export const EntitiesRefreshButton: React.FC<{
  shouldRenderRefreshButton: 'loading' | 'render' | 'not-render';
  onClick: () => void;
}> = ({ shouldRenderRefreshButton, onClick }) => (
  <>
    {(shouldRenderRefreshButton === 'render' || shouldRenderRefreshButton === 'loading') && (
      <Button
        theme="primary"
        onClick={onClick}
        loading={shouldRenderRefreshButton === 'loading'}
        disabled={shouldRenderRefreshButton === 'loading'}
        data-testid={
          shouldRenderRefreshButton === 'loading'
            ? TestID.RefreshEntitiesLoadingButton
            : TestID.RefreshEntitiesButton
        }
      >
        Refresh
      </Button>
    )}
  </>
);
